const $ = require('jquery');

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.partner', {
            url: '/partner/:id',
            views: {
                'left-panel@shop': {
                    controller: [
                        'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                            $scope.showLeftPanel = function () {
                                return breakpointsService.isSmallFormat();
                            };
                        },
                    ],
                    template: '<wow-partner-small-format ng-if="showLeftPanel()"><wow-partner></wow-partner></wow-partner-small-format>',
                },
                'center-panel@shop': {
                    template: '<wow-partner></wow-partner>',
                },
            },
            onEnter() {
                $('.center-content').css('position', 'relative');
            },
            onExit() {
                $('.center-content').css('position', '');
            },
            data: {
                pageMetadata: [
                    '$state', 'PartnerService', function ($state, partnerService) {
                        return partnerService.getPartner($state.params.id).then(response => ({
                            title: response.PartnerDto.Name,
                            metaDescription: response.PartnerDto.Name,
                        }));
                    },
                ],
            },
        })
        .state('shop.partnerbranch', {
            url: '/partnerbranch/:id',
            views: {
                'left-panel@shop': {
                    controller: [
                        'BreakpointsService', '$scope', function (breakpointsService, $scope) {
                            $scope.showLeftPanel = function () {
                                return breakpointsService.isSmallFormat();
                            };
                        },
                    ],
                    template: '<wow-partner-small-format ng-if="showLeftPanel()"></wow-partner-small-format>',
                },
            },
            data: {
                pageMetadata: [
                    '$state', 'PartnerService', function ($state, partnerService) {
                        return partnerService.getBranch($state.params.id).then(response => ({
                            title: response.PartnerBranchName,
                            metaDescription: response.PartnerBranchName,
                        }));
                    },
                ],
            },
        })
        .state('shop.conveniencepack', {
            url: '/conveniencepack/:packId?{pageNumber:int}&{sortBy}',
            reloadOnSearch: false,
            views: {
                'center-panel@shop': {
                    controller: ['$state', 'ProductGroupService', function ($state, productGroupService) {
                        this.$state = $state;

                        productGroupService.selectProductGroup($state.params.packId);
                    }],
                    controllerAs: '$ctrl',
                    template: `
                        <wow-convenience-pack-tile-list
                            pack-id="$ctrl.$state.params.packId"
                            page-number="$ctrl.$state.params.pageNumber || 1"
                            sort-by="$ctrl.$state.params.sortBy">
                        </wow-convenience-pack-tile-list>
                    `,
                },
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/partners.js